// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2I66g","image":"Header_image__1HSx3","name":"Header_name__3u1bc","info":"Header_info__13jMJ","infoRow":"Header_infoRow__dQdO1"};